import styled from '@emotion/styled'

export const QuoteViewSidebarWrapper = styled.div`
  width: 218px;
  position: sticky;
  top: 0;
`
